export default __webpack_public_path__ + "static/media/fa-light-300.620c1bab.svg";